<script setup lang="ts">
// Types
import type { TableCellProps } from "@/dsComponents/Table/types";

// Components
import Avatar from "@/dsComponents/Avatar/Avatar.vue";

withDefaults(defineProps<TableCellProps>(), {
    fontType: "regular",
    size: "sm",
});
</script>
<template>
    <div class="ds-table-cell-component" @click="onClick">
        <Avatar v-bind="avatarProps" v-if="avatarProps" />
        <i v-if="icon" :class="[`ti ti-${icon.iconType}`, icon.iconColor]" />
        <div class="right">
            <span :class="['table-cell-title', fontType, size, fontColor]">{{ cellTitle }}</span>
            <span :class="['table-cell-description', fontType, fontColor]" v-if="description">{{ description }}</span>
        </div>
    </div>
</template>
<style scoped lang="scss">
.ds-table-cell-component {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: 100%;
    gap: var(--spacing-md, 8px);
    align-items: center;

    .table-cell-title,
    .table-cell-description {
        white-space: nowrap;
    }

    .table-cell-title {
        color: var(--text-main-900, #00061aff);
        font-weight: 400;
        @include font-size-13;

        &.md {
            @include font-size-14;
        }

        &.leading {
            font-weight: 500;
        }

        &.passive {
            color: var(--text-sub-600, #494e61ff);
        }
    }

    .table-cell-description {
        color: var(--text-sub-600, #494e61ff);
        font-weight: 400;
        @include font-size-12;

        &.passive {
            color: var(--text-soft-400, #9297aaff);
        }
    }

    .right {
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;

        .table-cell-title,
        .table-cell-description {
            &.grey {
                color: var(--icon-soft-400, #9297aaff);
            }

            &.purple {
                color: var(--purple-base, #7520e6ff);
            }

            &.black {
                color: var(--bg-strong-900, #00061aff);
            }

            &.blue {
                color: var(--blue-base, #2051f8ff);
            }

            &.red {
                color: var(--red-base, #e51940ff);
            }

            &.yellow {
                color: var(--yellow-base, #fab305ff);
            }

            &.green {
                color: var(--green-base, #00a355ff);
            }

            &.orange {
                color: var(--orange-base, #ff5006ff);
            }
        }
    }

    .ti {
        font-size: 16px;
        &.grey {
            color: var(--icon-soft-400, #9297aaff);
        }

        &.purple {
            color: var(--purple-base, #7520e6ff);
        }

        &.black {
            color: var(--bg-strong-900, #00061aff);
        }

        &.blue {
            color: var(--blue-base, #2051f8ff);
        }

        &.red {
            color: var(--red-base, #e51940ff);
        }

        &.yellow {
            color: var(--yellow-base, #fab305ff);
        }

        &.green {
            color: var(--green-base, #00a355ff);
        }

        &.orange {
            color: var(--orange-base, #ff5006ff);
        }
    }
}
</style>
